import { sendGet } from "./axios";

export const getFilterOptions = () => sendGet("/dm/data/filters");

// Build the query string for /dm/data/filtered. Empty filter values are left out.
export const buildFilteredQuery = ({ level, code, quarter, filters = {} }) => {
  const params = new URLSearchParams();
  params.set("level", level);
  if (level !== "country" && code !== undefined && code !== null) {
    params.set("code", code);
  }
  params.set("quarter", quarter);
  Object.entries(filters).forEach(([key, value]) => {
    if (value && value !== "all") params.set(key, value);
  });
  return params.toString();
};

// One quarter of indices for a country/province/hospital, restricted to a subgroup
export const getFilteredData = (args) => sendGet(`/dm/data/filtered?${buildFilteredQuery(args)}`);
